// hooks/useDeleteBranch.ts
import { useState } from "react";
import { notifyError, notifySuccess } from "../../../../../assets/toastService";

export const useDeleteBranch = (deleteBranch: (id: string) => Promise<boolean>, fetchBranches: () => void) => {
  const [selectedDelBranchId, setSelectedDelBranchId] = useState<string | null>(null);

  const handleDelete = (branchId: string) => setSelectedDelBranchId(branchId);

  const confirmDelete = async () => {
    if (!selectedDelBranchId) return;
    try {
      const success = await deleteBranch(selectedDelBranchId);
      if (success) {
        notifySuccess("Branch deleted successfully");
        setTimeout(() => {
          fetchBranches?.();
      }, 3000);
      } else {
        notifyError("Failed to delete branch");
      }
    } catch (err) {
      notifyError("An unexpected error occurred while deleting branch");
    } finally {
      setSelectedDelBranchId(null);
    }
  };

  return { selectedDelBranchId, setSelectedDelBranchId, handleDelete, confirmDelete };
};
